/**
 * @generated SignedSource<<bbaab25d796323fee954df4c4d86537d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MuteChatThreadInput = {
  chatThreadId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  muted: boolean;
};
export type ChatThreadUsers_MuteChatThreadMutation$variables = {
  input: MuteChatThreadInput;
};
export type ChatThreadUsers_MuteChatThreadMutation$data = {
  readonly muteChatThread: {
    readonly chatThread: {
      readonly id: string;
      readonly muted: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ChatThreadUsers_MuteChatThreadMutation = {
  response: ChatThreadUsers_MuteChatThreadMutation$data;
  variables: ChatThreadUsers_MuteChatThreadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MuteChatThreadPayload",
    "kind": "LinkedField",
    "name": "muteChatThread",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatThread",
        "kind": "LinkedField",
        "name": "chatThread",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "muted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadUsers_MuteChatThreadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatThreadUsers_MuteChatThreadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5a8f6b749dd71b50075d431c1cd1b09",
    "id": null,
    "metadata": {},
    "name": "ChatThreadUsers_MuteChatThreadMutation",
    "operationKind": "mutation",
    "text": "mutation ChatThreadUsers_MuteChatThreadMutation(\n  $input: MuteChatThreadInput!\n) {\n  muteChatThread(input: $input) {\n    chatThread {\n      muted\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7b0c4a899ec631ac67c85fc4934e667";

export default node;
